export function localisationRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_LOCALISATION_START":           
        case "FETCH_LOCALISATIONS_START":                                 
        case "UPDATE_LOCALISATION_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_LOCALISATION_FULFILLED":           
        case "FETCH_LOCALISATIONS_FULFILLED":                                 
        case "UPDATE_LOCALISATION_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_LOCALISATION_ERROR":
        case "FETCH_LOCALISATIONS_ERROR":
        case "UPDATE_LOCALISATION_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}